export default {
  PostedState: 'Trạng thái ghi sổ',
  PostedDate: 'Ngày hạch toán',
  NoData: 'Không có dữ liệu',
  NotFoundData: 'Không tìm thấy dữ liệu phù hợp',
  EmptyData: 'Chưa có dữ liệu',
  Search: 'Tìm kiếm...',
  FeaturesIsDeveloping: 'Tính năng đang phát triển',
  TotalAmount: 'Tổng tiền',
  GeneralInfo: 'Thông tin chung',
  Guide: 'Hướng dẫn',
  Help: 'Trợ giúp',
  Email: 'Email',
  Other: 'Khác',
  CustomizeLayout: 'Tùy chỉnh giao diện',
  VoucherReference: 'CT tham chiếu',
  VoucherReferenceTooltip: 'Chứng từ tham chiếu',
  DefaultCategory: 'Lấy lại danh mục ngầm định',
  ConvertCategory: 'Phục hồi chỉ tiêu từ MISA Bamboo Desktop',
  TextButton: {
    ConnectNow: 'Kết nối ngay',
    Connected: 'Đã kết nối',
    Disconnect: 'Ngừng kết nối',
    Disconnect2: 'Ngắt kết nối', // pntoan 28.2.2024 Vẫn là chức năng disconnect nhưng text khác
    BatchExecution: 'Thực hiện hàng loạt',
    Filter: 'Lọc',
    Guide: 'Hướng dẫn',
    Shortcut: 'Phím tắt',
    Add: 'Thêm',
  },
  Text: {
    ViewHelpHere: 'Xem hướng dẫn tại đây',
  },
  Command: {
    Add: 'Thêm',
    Edit: 'Sửa',
    Postpone: 'Hoãn',
    Update: 'Cập nhật',
    Delete: 'Xóa',
    DeleteField: 'Xóa thông tin',
    Duplicate: 'Nhân bản',
    More: 'Thêm nữa...',
    Posted: 'Ghi sổ',
    UnPosted: 'Bỏ ghi',
    Save: 'Lưu|Cất',
    SaveNew: 'Lưu & Thêm',
    Close: 'Đóng',
    Hide: 'Ẩn',
    Help: 'Giúp',
    Cancel: 'Hủy',
    Accept: 'Đồng ý',
    SaveAndNew: 'Lưu và thêm mới',
    Confirm: 'Xác nhận',
    NotConfirm: 'Không xác nhận',
    Export: 'Xuất khẩu',
    Finish: 'Hoàn thành',
    Load: 'Nạp',
    Print: 'In',
    Filter: 'Lọc',
    Refresh: 'Lấy lại dữ liệu',
    Setting: 'Thiết lập',
    Default: 'Mặc định',
    List: 'Danh sách',
    AddDetail: 'Thêm dòng',
    AddDetailShortKey: 'Thêm dòng (F9)',
    Import: 'Nhập khẩu',
    Logout: 'Đăng xuất',
    Next: 'Tiếp theo',
    Back: 'Quay lại',
    Move: 'Di chuyển',
    Minimize: 'Thu gọn',
    CreateFormular: 'Lập công thức',
  },
  List: {
    SearchEmptyText: 'Tìm kiếm',
  },
  /**
   * Đoạn này tạm thời vẫn để viết thường vì chưa care được hết vùng ảnh hưởng
   * ndhieu3 20.04.2023
   */
 
  module: {
    employee: 'Nhân viên',
    employeeType: 'Loại cán bộ',
    payrollItem: 'Khoản lương',
    inventoryItem: 'Vật tư',
    toolList: 'Công cụ dụng cụ',
    buPlanWithDraw: 'Rút dự toán tiền gửi',
    bUTransfer: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',
    accountingObject: 'Cán bộ',
    diDepartment: 'Phòng/ban',
    account: 'Tài khoản',
    currency: 'Loại tiền',
    baWithdraw: 'Chi tiền gửi',
    inventoryCategory: 'Loại vật tư/CCDC',
    diStock: 'Kho',
    budgetPlan: 'Dự toán ngân sách',
    buPlanReceipt: 'Nhận dự toán',
    buPlanCancel: 'Hủy dự toán',
    diBudgetChapter: 'Chương',
    diBudgetProvide: 'Mã dự phòng',
    diFund: 'Quỹ tiền',
    diFundStructure: 'Nội dung chi phí',
    diActivity: 'Hoạt động tài chính',
    diBranch: 'Đơn vị trực thuộc',
    bankInfoCategory: 'Loại tài khoản tiền gửi kho bạc',
    budgetGroupItem: 'Nhóm mục chi',
    budgetSourceProperty: 'Tính chất nguồn kinh phí',
    cAReceipt: 'Phiếu thu',
    diBudgetSource: 'Nguồn kinh phí',
    diBankInfo: 'Tài khoản Ngân hàng, Kho bạc',
    diBankInfoCategory: 'Loại tài khoản Ngân hàng, Kho bạc',
    bUVoucherList: 'Bảng kê chứng từ thanh toán',
    diBudgetItem: 'Mục - Tiểu mục',
    BUPlanAdjustment: 'Điều chỉnh dự toán',
    budgetKindItem: 'Loại - Khoản',
    sUTransfer: 'Điều chuyển CCDC',
    sUIncrement: 'Ghi tăng CCDC',
    sUDecrement: 'Ghi giảm CCDC',
    bUPlanWDAdjustment: 'Điều chỉnh kinh phí',
    pUInvoice: 'Hóa đơn mua hàng',
    inTransfer: 'Chuyển kho',
    iNAdjustment: 'Điều chỉnh tồn kho',
    statistic: 'Mã thống kê',
    purchasePurpose: 'Nhóm HH, DV mua vào',
    cAPayment: 'Phiếu chi',
    budgetFees: 'Phí, lệ phí',
    accountTransfer: 'Tài khoản kết chuyển',
    bADeposit: 'Phiếu thu',
    cAReceiptSale: 'Phiếu thu bán hàng',
    sAInvoice: 'Bán hàng chưa thu tiền',
    bABankTransfer: 'Chuyển tiền nội bộ',
    bUBudgetReserve: 'Dự toán giữ lại',
    gLVoucher: 'Chứng từ nghiệp vụ khác',
    activity: 'Hoạt động',
    task: 'Nhiệm vụ',
    customerVendor: 'Khách hàng, nhà cung cấp',
    accountingObjectCategory: 'Loại khách hàng, nhà cung cấp',
    invoiceFormNumber: 'Mẫu số hóa đơn',
    voucherType: 'Loại chứng từ',
    sAReturn: 'Hàng bán trả lại',
    gLVoucher: 'Chứng từ nghiệp vụ khác',
    activity: 'Hoạt động',
    bUCommitmentRequest: 'Đề nghị cam kết chi',
    bUCommitmentAdjustment: 'Điều chỉnh cam kết chi',
    bUOpeningCommitment: 'Nhập cam kết chi ban đầu',
    project: 'Chương trình mục tiêu, dự án',
    targetProgram: 'Chương trình mục tiêu',
    projectBudgetDetail: 'Chi tiết tổng mức đầu tư',
    contract: 'Hợp đồng',
    topic: 'Đề tài',
    gLVoucherList: 'Bảng tổng hợp chứng từ',
    workItem: 'Công trình, HMCT',
    BUTransferPurchase: 'Chuyển khoản kho bạc mua vật tư hàng hóa',
    INInwardFromINAdjustment: 'Nhập kho từ điều chỉnh tồn kho',
    INInwardFromINAdjustmentChangeAmount: 'Nhập kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)',
    INOutwardFromINAdjustment: 'Xuất kho từ điều chỉnh tồn kho',
    INOutwardFromINAdjustmentChangeAmount: 'Xuất kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)',
    inOutward: 'Xuất kho',
    FAVoucherDepreciation: 'Lấy hao mòn tự nhiên TSCĐ từ QLTS.VN',
    FAVoucherIncreament: 'Ghi tăng TSCĐ từ QLTS.VN',
    FAVoucherAdjustment: 'Đánh giá lại TSCĐ từ QLTS.VN',
    FAVoucherDepreciate: 'Lấy khấu hao TSCĐ từ QLTS.VN',
    FAVoucherDecrement: 'Ghi giảm TSCĐ từ QLTS.VN',
    bATransfer: 'Tiền đang chuyển',
    bUPlanImport: 'Nhập dự toán',
    cRERepList: 'Báo cáo tài chính',
    openingSupplyEntry: 'Công cụ dụng cụ',
    diAutoBusiness: 'Định khoản tự động',
    fundStructure: 'Cơ cấu vốn',
    cRERepExportList: 'Nộp báo cáo cho kho bạc',
    defaultAccount: 'Tài khoản ngầm định',
    cRERepSettlement: 'Báo cáo quyết toán',
    cAReceiptSale: 'Thu tiền khách hàng',
    salaryScale: 'Ngạch lương',
    paOption: 'Quy định lương, thuế, bảo hiểm',
    pASortEmployee: 'Sắp xếp cán bộ',
    toolType: 'Loại công cụ dụng cụ',
    toolList: 'Công cụ dụng cụ',
    sASaleInvoice: 'Hóa đơn',
    gLProfitLossTransferVoucher: 'Xác định kết quả hoạt động',
    openingAccountEntry: 'số dư của tài khoản',
    crerepexporttaxlist: 'Nộp báo cáo cho cơ quan thuế',
    pAStatisticalDayOff: 'Bảng tổng hợp ngày nghỉ/làm thêm, làm đêm',
    pAPersonalIncomeTax: 'Bảng tính thuế TNCN',
    pAOtherIncome: 'Thu nhập không thường xuyên', // vqphong - 19/10/2022
    pASalary: 'Bảng lương',
    userManagement: 'Người dùng',
    sysUser: 'người dùng',
    sysRole: 'vai trò',
    role: 'vai trò',
    fAIncrementDecrement: 'Ghi giảm tài sản cố định',
    diFixedAssetCategory: 'Loại tài sản cố định',
    fixedAsset: 'Tài sản cố định',
    fAAdjustment: 'Đánh giá lại tài sản cố định',
    fAIncrement: 'Nhận bằng hiện vật và ghi tăng',
    fADepreciation: 'Tính hao mòn tài sản cố định',
    fATransfer: 'Điều chuyển tài sản cố định',
    fARevenue: 'Doanh thu',
    tACircularVATDeclaration: 'tờ khai thuế',
    fADecrement: 'Ghi giảm tài sản cố định',
    bUB58KTNN: 'báo cáo',
    fADevaluation: 'Trích khấu hao tài sản cố định',
    cAReceiptFixedAsset: 'Bán tài sản cố định',
    dvcFile: 'hồ sơ',
    diHamlet: 'Thôn xóm',
    diBudgetItemDetail: 'Tiết tiểu mục',
    diAccountingObjectCategory: 'Loại đối tượng',
    employeeIncomeTax: 'Biểu tính thuế thu nhập',
    diAccountingObject: 'Đối tượng',
    diAccountingObjectList: 'danh sách đối tượng',
    diActivityCategory: 'Loại hoạt động tài chính',
    diStatistic: 'Mã thống kê',
    diContract: 'Hợp đồng',
    diLocalBudgetItem: 'Khoản chi xã',
    diBudgetChapter: 'Chương',
    diBudgetChapterCode: 'Mã chương',
    diBudgetChapterName: 'Tên chương',
    diEquipmentInventoryItem: 'Công cụ dụng cụ',
    InInward: 'Nhập kho',
    eReceipt: 'Biên lai',
    eReceiptSummary: 'Bảng tổng hợp biên lai',
    initialAccountBalance: 'Số dư ban đầu',
    accountingObjectBalance: 'Số dư theo đối tượng',
    bankAccountBalance: 'Số dư tài khoản ngân hàng',
    inventoryMaterial: 'Tồn kho vật tư',
    anotherAccountBalance: 'Số dư tài khoản khác',
    glVoucherlist: 'Bảng tổng hợp chứng từ cùng loại',
    glRegisterlist: 'Chứng từ ghi sổ',
    glAccountTransfer: 'Phiếu kết chuyển tài khoản/ quyết toán',
    planActivityTemp: 'chỉ tiêu',
    constructionBudget: 'Kế hoạch vốn đầu tư xây dựng cơ bản',
    BUPlanActivityBudgetList: 'Dự toán thu',
    BuFinancialActivities: 'Kế hoạch thu chi các hoạt động tài chính khác',
    buTransfer: 'Chuyển khoản kho bạc',
    buPlanWdAdjustment: 'điều chỉnh kinh phí',
    //#region Lương
    pAGLPayrollExpense: 'Hạch toán chi phí lương, BH, KPCĐ',
    saVoucher: 'Chứng từ trả lương, bảo hiểm',

    //#endregion
    dvcBudget: 'ĐVQHNS/ Dự án',

    caFundInventory: 'Biên bản kiểm kê quỹ',
    expenseNormRegulation: 'Tiêu chuẩn định mức',
  },
  // Các cột thường dùng
  CommonColumn: {
    RefNo: 'Số CT',
    RefNoTooltip: 'Số chứng từ',
    RefDate: 'Ngày CT',
    RefDateTooltip: 'Ngày chứng từ',
    AccountingDate: 'Ngày HT',
    Description: 'Diễn giải',
    FullName: 'Họ tên',
    Address: 'Địa chỉ',
    Currency: 'Loại tiền',
    DecisionDate: 'Ngày QĐ',
    DecisionDateTooltip: 'Ngày quyết định',
    DecisionNo: 'Số QĐ',
    DecisionNoTooltip: 'Số quyết định',
    BuPlanTitle: 'Thuộc dự toán',
  },
  // Label của các combobox hay dùng config chung ở đây
  LabelCombobox: {
    Fund: 'Quỹ tiền',
    BudgetKindItem: 'Khoản',
    Year: 'Năm',
    ProjectXDCB: 'Dự án, Công trình, HMCT',
    ProjectXDCBTooltip: 'Dự án, Công trình, Hạng mục công trình',
    ReportPeriod: 'Kỳ báo cáo',
    FromMonth: 'Từ tháng',
    ToMonth: 'Đến tháng',
    Month: 'Tháng',
    CompareType: 'Đối chiếu theo',
    Quater: 'Quý',
    BudgetSource: 'Nguồn',
    BudgetChapter: 'Chương',
    Project: 'CTMT, DA',
    ProjectTooltip: 'Chương trình mục tiêu, dự án',
  },

  // Title của các popup hay dùng config chung ở đây
  PopupTitle: {
    ReportParam: 'Tham số báo cáo',
    ComparisonReportTemplate: 'Mẫu báo cáo đối chiếu',
  },
  //các màn module cho hướng dẫn sd
  moduleGuide: {
    budgetplan:'Dự toán ngân sách',
    cash: 'Tiền mặt',
    deposits: 'Tiền gửi',
    receipt: 'Biên lai',
    tools: 'Vật tư, công cụ dụng cụ',
    favoucherqlts: 'Tài sản cố định',
    salary: 'Lương',
    summary: 'Tổng hợp',
  },
};
